import React, { Component } from 'react';

import './App.css';

class UnderConstruction extends Component {
	render() {
		return (
			<div className="center">
				<div className="margin">Under Construction</div>

				<img
					className="margin"
					src={
						'https://s3-us-west-2.amazonaws.com/mjm5vp.images/135f946ecbb14c05eff67b947966b4f2.jpg'
					}
				/>
				<div className="linkedInDiv margin">
					<a
						href="https://www.linkedin.com/in/mark-moeller-9b721b84/"
						target="_blank"
					>
						<img
							className="linkedInDiv"
							src="/images/linkedin-logo.png"
							alt="linkedin"
						/>
					</a>
				</div>
			</div>
		);
	}
}

export default UnderConstruction;



// WEBPACK FOOTER //
// ./src/UnderConstruction.js